module.exports = __webpack_public_path__ + "img/51_23.cb4b35c9.png";